import { QBankStructureStatus } from '@exam-management/graphql';
import { LabelColor } from '@shared/components';

export const QBS_COLOR_STATUS = {
  [QBankStructureStatus.Draft]: LabelColor.INFO,
  [QBankStructureStatus.Published]: LabelColor.SUCCESS,
  [QBankStructureStatus.Unpublished]: LabelColor.WARNING,
  [QBankStructureStatus.Archived]: LabelColor.GREY,
};

export const QBS_STATUS_TEXT = {
  [QBankStructureStatus.Draft]: 'Draft',
  [QBankStructureStatus.Published]: 'Published',
  [QBankStructureStatus.Unpublished]: 'Pending',
  [QBankStructureStatus.Archived]: 'Disabled',
};
